/**
 * Query key factory. `latest` keys on its limit: two rows asking for different counts must not
 * share one answer. A post keys on its id, which is also the route key.
 */
export const postsKeys = {
  all: ['posts'] as const,
  latest: (limit: number) => [...postsKeys.all, 'latest', limit] as const,
  post: (postId: number) => [...postsKeys.all, 'post', postId] as const,
}
